/**
 * マニフェスト集計CSV
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/reports/manifests`

const report_manifest = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * @return {Promise<unknown>}
     */
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          resolve(data)
        })
      })
    },
    create({ commit }, { conditions, output_type }) {
      let api_path = API_PATH
      if (output_type === 'csv') {
        api_path = `${API_PATH}.csv`
      }
      return new Promise((resolve) => {
        Vue.$http.post(api_path, conditions).then(data => {
          resolve(data)
        })
      })
    }
  },
  mutations: {
  },
}

export default report_manifest
